<template>
  <div class="relative w-[70px] shrink-0">
    <input
      ref="inputElement"
      type="number"
      v-bind="$attrs"
      :value="props.modelValue"
      @input="onInput"
      class="pr-6"
    />

    <button
      type="button"
      @click="step('up')"
      class="absolute top-1 right-2"
      tabindex="-1"
    >
      <ChevronUpIcon class="w-4 h-4 text-gray-500" />
    </button>
    <button
      type="button"
      @click="step('down')"
      class="absolute bottom-1 right-2"
      tabindex="-1"
    >
      <ChevronDownIcon class="w-4 h-4 text-gray-500" />
    </button>
  </div>
</template>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type='number'] {
  -moz-appearance: textfield;
}
</style>

<!--
@Todo: This can be moved once on Vue 3.3
See: https://blog.vuejs.org/posts/vue-3-3#defineoptions
-->
<script>
export default {
  inheritAttrs: false
}
</script>

<script setup>
import { ref } from 'vue'
import { ChevronUpIcon, ChevronDownIcon } from '@heroicons-2/vue/24/outline'

const props = defineProps(['modelValue'])
const emit = defineEmits(['update:modelValue'])

const inputElement = ref(null)

function onInput() {
  emit('update:modelValue', inputElement.value.value)
}

function step(direction) {
  inputElement.value[
    {
      up: 'stepUp',
      down: 'stepDown'
    }[direction]
  ]()
  onInput()
}
</script>
